/// <amd-module name="Feed/Common/Protocols/Ivy/RestClient/Ivy" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   packaging\client\ivy\webapi\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Ivy from "Feed/Common/Protocols/Ivy/Contracts/Ivy";

import { IIvyRestClient } from "Feed/Common/Protocols/Ivy/RestClient/Ivy.Types";

export { IIvyRestClient } from "Feed/Common/Protocols/Ivy/RestClient/Ivy.Types";

class IvyRestClient extends RestClientBase implements IIvyRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param reference - 
     * @param feed - 
     */
    public async tryAddReferences(
        reference: Ivy.IvyBlobReference,
        feed: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/blob",
            routeValues: {
                feed: feed
            },
            body: reference
        });
    }

    /**
     * @param feed - 
     * @param name - 
     * @param version - 
     */
    public async packageDelete(
        feed: string,
        name: string,
        version: string
        ): Promise<number> {

        const queryValues: any = {
            name: name,
            version: version
        };

        return this.beginRequest<number>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/metadata",
            routeValues: {
                feed: feed
            },
            queryParams: queryValues
        });
    }

    /**
     * @param feed - 
     * @param name - 
     * @param version - 
     * @param includeModule - 
     * @param includePromotion - 
     */
    public async packageInfo(
        feed: string,
        name: string,
        version: string,
        includeModule?: boolean,
        includePromotion?: boolean
        ): Promise<Ivy.IvyPackage> {

        const queryValues: any = {
            name: name,
            version: version,
            includeModule: includeModule,
            includePromotion: includePromotion
        };

        return this.beginRequest<Ivy.IvyPackage>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/metadata",
            routeValues: {
                feed: feed
            },
            queryParams: queryValues
        });
    }

    /**
     * @param feed - 
     * @param status - 
     * @param name - 
     * @param version - 
     */
    public async packagePromote(
        feed: string,
        status: string,
        name: string,
        version: string
        ): Promise<Ivy.IvyPromotionStatus> {

        const queryValues: any = {
            name: name,
            version: version
        };

        return this.beginRequest<Ivy.IvyPromotionStatus>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/promotion/{status}",
            routeValues: {
                feed: feed,
                status: status
            },
            queryParams: queryValues
        });
    }

    /**
     * @param feed - 
     * @param name - 
     * @param version - 
     */
    public async packagePromotionStatus(
        feed: string,
        name: string,
        version: string
        ): Promise<Ivy.IvyPromotionStatus> {

        const queryValues: any = {
            name: name,
            version: version
        };

        return this.beginRequest<Ivy.IvyPromotionStatus>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/promotion/{status}",
            routeValues: {
                feed: feed
            },
            queryParams: queryValues
        });
    }

    /**
     * @param feed - 
     * @param status - 
     */
    public async promotionStatusAdd(
        feed: string,
        status: string
        ): Promise<Ivy.IvyPromotionStatus> {

        return this.beginRequest<Ivy.IvyPromotionStatus>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/promotion/{status}",
            routeValues: {
                feed: feed,
                status: status
            }
        });
    }

    /**
     * @param feed - 
     * @param status - 
     */
    public async promotionStatusDelete(
        feed: string,
        status: string
        ): Promise<Ivy.IvyPromotionStatus> {

        return this.beginRequest<Ivy.IvyPromotionStatus>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/promotion/{status}",
            routeValues: {
                feed: feed,
                status: status
            }
        });
    }

    /**
     * @param feed - 
     */
    public async promotionStatusList(
        feed: string
        ): Promise<Ivy.IvyPromotionStatus[]> {

        return this.beginRequest<Ivy.IvyPromotionStatus[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/promotion/{status}",
            routeValues: {
                feed: feed
            }
        });
    }

    /**
     * @param feed - 
     * @param status - 
     * @param renameTo - 
     */
    public async promotionStatusRename(
        feed: string,
        status: string,
        renameTo: string
        ): Promise<Ivy.IvyPromotionStatus> {

        const queryValues: any = {
            renameTo: renameTo
        };

        return this.beginRequest<Ivy.IvyPromotionStatus>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/packaging/feeds/{feed}/ivy/promotion/{status}",
            routeValues: {
                feed: feed,
                status: status
            },
            queryParams: queryValues
        });
    }

}

export const IvyClientName = "IIvyRestClient";

export function getIvyClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IIvyRestClient {
    return pageContext.getRestClient<IIvyRestClient>(IvyClientName, options);
}

RestClients.add(IvyClientName, { 
    factory: IvyRestClient,
    options: {
        serviceInstanceType: "00000030-0000-8888-8000-000000000000"
    }
});
